<template>
  <!-- prettier-ignore -->
  <FormItem :error="error" :prop="fieldName">
    <span v-if="label !== undefined" slot="label" class="n-field-label">{{ $t(`label.${label}`) }}</span>
    <span v-else-if="customLabel !== undefined" slot="label" class="n-field-label">{{ customLabel }}</span>
    <div :class="modifiedIcon ? 'n-input-item-icon' : 'n-input-item'">
      <i-select ref="select" :value="value" :placeholder="placeholder === undefined ? '' : this.$t(`label.${placeholder}`)" :filterable="filterable" :clearable="clearable" :disabled="disabled" transfer @on-open-change="onOpenChange" @on-change="v => { this.$emit('input', v); this.$emit('on-change', v); }" @on-select="v => { this.$emit('on-select', v) }">
        <template v-if="allOption">
          <Option :value="allOptionValue" :style="{ borderBottom: options.length > 0 ? '1px solid #e8eaec' : '0' }">ALL</Option>
        </template>
        <Option v-for="option in options" :key="option.value" :value="option.value">{{ option.name }}</Option>
      </i-select>
    </div>
    <Tooltip v-if="isModified" placement="right-start" :max-width="500" :content="showName(initValue)" transfer class="ml-2">
      <Icon custom="fas fa-pen" size="14" style="cursor: pointer;" />
    </Tooltip>
  </FormItem>
</template>

<script>
import Base from '../base';
import { isEmpty, isEmptyOption } from '@/helpers/utils';
import { getSelection } from '@/store';

export default Base.extend({
  name: 'NFieldSelection',
  props: {
    value: [String, Number],
    selectionName: String,
    allOption: Boolean,
    allOptionValue: {
      type: Number,
      default: 0,
    },
    extraGroup: [String, Number],
    filterable: {
      type: Boolean,
      detail: false,
    },
    clearable: {
      type: Boolean,
      detail: false,
    },
  },
  computed: {
    options() {
      let options = getSelection(this.selectionName);
      if (!isEmpty(this.extraGroup) && !isEmpty(options)) options = options.filter(v => v.extra['$group'] === this.extraGroup);
      return options;
    },
    isModified() {
      return this.showModifyIcon && this.initValue !== this.value;
    },
  },
  created() {
    this.initValue = this.value;
  },
  methods: {
    onOpenChange(isOpen) {
      if (!isOpen || !isEmptyOption(this.value)) return;
      this.$nextTick(() => {
        this.$refs.select.$el.lastChild.scrollTop = 0;
      });
    },
    showName(value) {
      if (isEmpty(value)) return null;
      if (this.allOption && value === this.allOptionValue) return 'ALL';
      let option = this.options.find(f => f.value === value);
      if (isEmpty(option) || value === this.allOptionValue) return null;
      return option.name;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '../base';
@import 'style';
</style>
